import { render, staticRenderFns } from "./SEOPageEdit.vue?vue&type=template&id=51a3616e"
import script from "./SEOPageEdit.vue?vue&type=script&lang=js"
export * from "./SEOPageEdit.vue?vue&type=script&lang=js"
import style0 from "./SEOPageEdit.vue?vue&type=style&index=0&id=51a3616e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports